// extracted by mini-css-extract-plugin
export default {"image":"TI1b5D"};